define.alias("ember-math-helpers/helpers/cos", "media/helpers/cos");